import request from '../../lib/helpers/requestApi';
import { ResponseContainers } from '../../types/containers';

/** Получение списка контейнеров */
export const getContainers = request<ResponseContainers[]>({
  method: 'container.getList',
});
